import type { ReactNode } from 'react';

import { Typography } from '@capsule/consumer-design-system';

import { css } from 'styled-components';

import { Container } from './styles';

interface StepProps {
  title: ReactNode;
  text: ReactNode;
  children: ReactNode;
}

const Step = ({ title, text, children }: StepProps) => {
  return (
    <Container>
      <Typography
        variant={{ base: 'displayXl', smallDown: 'heading2' }}
        css={css`
          margin-bottom: ${({ theme }) => theme.space.s5};
        `}
      >
        {title}
      </Typography>
      <Typography variant="body">{text}</Typography>
      <>{children}</>
    </Container>
  );
};

export default Step;
